var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: _vm.steps === 1 ? "提示" : "添加渠道",
            "mask-closable": false,
            closable: false
          },
          model: {
            value: _vm.twoIntention,
            callback: function($$v) {
              _vm.twoIntention = $$v
            },
            expression: "twoIntention"
          }
        },
        [
          _vm.twoIntentionData.tips_status === 1
            ? _c("div", [
                _vm.steps === 1
                  ? _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c("p", [
                        _vm._v(
                          "客户：" +
                            _vm._s(_vm.twoIntentionData.name) +
                            " " +
                            _vm._s(_vm.twoIntentionData.phone) +
                            " 已存在于 CRM，"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("当前跟进门店：\n                    "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.twoIntentionData.follow_store_names.join("、")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("是否增加二次渠道，并在 "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.twoIntentionData.store_name))
                        ]),
                        _vm._v(" 进行回访跟进?")
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm.twoIntentionData.tips_status === 2
            ? _c("div", [
                _vm.steps === 1
                  ? _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c("p", [_vm._v("该客户已存在于本店")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "listItem" }, [
                        _c("div", [_vm._v("当前跟进人：")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(_vm.twoIntentionData.follow_list, function(
                            item,
                            index
                          ) {
                            return _c("p", { key: index }, [
                              _vm._v(
                                _vm._s(item.created_at) +
                                  "\n                         分配给 " +
                                  _vm._s(item.follow_department_name) +
                                  " " +
                                  _vm._s(item.follow_user_name) +
                                  "\n                         "
                              ),
                              _c(
                                "span",
                                {
                                  class:
                                    item.follow_status == 4 ? "colorRed" : ""
                                },
                                [
                                  _vm._v(
                                    "\n                             " +
                                      _vm._s(item.follow_status_text)
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("是否需要通过“增加渠道”成为第二录入人？")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*第二录入人能看到该客户的回访信息")
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm.twoIntentionData.tips_status === 3
            ? _c("div", [
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _c(
                    "p",
                    [
                      _vm._v(
                        "客户：" +
                          _vm._s(_vm.twoIntentionData.name) +
                          " " +
                          _vm._s(_vm.twoIntentionData.phone) +
                          " 已于\n                    "
                      ),
                      _vm._l(_vm.twoIntentionData.sign_store_list, function(
                        item,
                        index
                      ) {
                        return _c(
                          "span",
                          { key: index, staticStyle: { color: "red" } },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                      _vm._v(
                        "\n                    签单若需创建二次签单意向，需完成离院结算"
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "系统房态的离院日期为：" +
                        _vm._s(_vm.twoIntentionData.leave_time)
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.steps === 2
            ? _c(
                "div",
                [
                  _c("Alert", { attrs: { type: "error" } }, [
                    _vm._v(
                      "增加渠道会让您成为第二录入人，可查看该客户所有回访信息"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "Form",
                    {
                      ref: "formValidate",
                      attrs: {
                        model: _vm.formItem,
                        rules: _vm.ruleValidate,
                        "label-width": 80
                      }
                    },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "14" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "渠道",
                                    prop: "department_id"
                                  }
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { placeholder: "请选择部门" },
                                      on: { "on-change": _vm.changeChannel },
                                      model: {
                                        value: _vm.formItem.department_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formItem,
                                            "department_id",
                                            $$v
                                          )
                                        },
                                        expression: "formItem.department_id"
                                      }
                                    },
                                    _vm._l(_vm.departmentList, function(item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id + "" }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "10" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    "label-width": 0,
                                    prop: "channel_id"
                                  }
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择渠道"
                                      },
                                      model: {
                                        value: _vm.formItem.channel_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formItem,
                                            "channel_id",
                                            $$v
                                          )
                                        },
                                        expression: "formItem.channel_id"
                                      }
                                    },
                                    _vm._l(_vm.channel, function(item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id + "" }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "渠道说明",
                                    prop: "channel_explain"
                                  }
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: 100,
                                      autosize: { minRows: 2, maxRows: 5 },
                                      placeholder:
                                        "请在100字内描述特有的渠道说明"
                                    },
                                    model: {
                                      value: _vm.formItem.channel_explain,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formItem,
                                          "channel_explain",
                                          $$v
                                        )
                                      },
                                      expression: "formItem.channel_explain"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "备注", prop: "remark" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: 200,
                                      autosize: { minRows: 2, maxRows: 5 },
                                      placeholder:
                                        "请在200字内描述增加渠道的原因"
                                    },
                                    model: {
                                      value: _vm.formItem.remark,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formItem, "remark", $$v)
                                      },
                                      expression: "formItem.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "", prop: "is_follow" } },
                                [
                                  _c(
                                    "Checkbox",
                                    {
                                      model: {
                                        value: _vm.formItem.is_follow,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formItem,
                                            "is_follow",
                                            $$v
                                          )
                                        },
                                        expression: "formItem.is_follow"
                                      }
                                    },
                                    [_vm._v("设自己为跟进人")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: {
                    type:
                      _vm.twoIntentionData.tips_status === 3
                        ? "primary"
                        : "text",
                    size: "large"
                  },
                  on: { click: _vm.handleCancel }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.twoIntentionData.tips_status === 3 ? "确认" : "取消"
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.twoIntentionData.tips_status != 3
                ? _c(
                    "Button",
                    {
                      attrs: {
                        type: "primary",
                        size: "large",
                        disabled: _vm.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit("formValidate")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.twoIntentionData.tips_status === 1 ||
                              _vm.twoIntentionData.tips_status === 2
                              ? "添加渠道"
                              : "确认"
                          ) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64d94aa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d94aa4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CRM_twoIntention.vue
// module id = null
// module chunks = 